import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DeliveryRate, DeliveryRateData, RadialDeliveryRates } from '../models/delivery-rates';

@Injectable()
export class DeliveryRatesService {
  readonly url = environment.apiUrl + '/admin/companies';
  readonly urlGlobal = environment.apiUrl + '/admin/delivery-rates';

  constructor(private http: HttpClient) {}

  getDeliveryRates = (companyId: number): Observable<DeliveryRateData> =>
    this.http.get(`${this.url}/${companyId}/delivery-rates`).pipe(map((r: any) => r['data']));

  createDeliveryRates = (
    companyId: number,
    data: DeliveryRate[]
  ): Observable<RadialDeliveryRates> =>
    this.http
      .post(`${this.url}/${companyId}/delivery-rates`, data)
      .pipe(map((r: any) => r['data']));

  updateDeliveryRates = (companyId: number, data: DeliveryRate[]): Observable<DeliveryRateData[]> =>
    this.http.put(`${this.url}/${companyId}/delivery-rates`, data).pipe(map((r: any) => r['data']));

  deleteDeliveryRate = (companyId: number, rateId: number) =>
    this.http.delete(`${this.url}/${companyId}/delivery-rates/${rateId}`);

  createGlobalDeliveryRates = (data: DeliveryRate[]): Observable<RadialDeliveryRates> =>
    this.http.post(this.urlGlobal, data).pipe(map((r: any) => r['data']));

  updateGlobalDeliveryRates = (data: DeliveryRate[]): Observable<DeliveryRateData[]> =>
    this.http.put(this.urlGlobal, data).pipe(map((r: any) => r['data']));

  deleteGlobalDeliveryRate = (rateId: number) => this.http.delete(`${this.urlGlobal}/${rateId}`);
}
